module.exports = __webpack_public_path__ + "static/media/login-image.de157086.svg";